/**
 * Generate random text.
 * @param {number} length How much.
 * @param {string} [chars] A set of characters to compose random text from.
 */
export const randomChars = (length: number, chars: string) => {
	if (!chars) {
		chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
	}
	let result = '';
	for (let i = length; i > 0; --i) {
		result += chars[Math.round(Math.random() * (chars.length - 1))];
	}
	return result;
};

export default randomChars;
